export const EDIT_APPLIANCE_ESTIMATES_MODEL_FRENCH_LOCALE = {
  editApplianceEstimatesModal: {
    title: "Modifier la déclaration des appareils",
    heatPumpToQualifyInfo: "L'adhérent a déclaré une pompe à chaleur en ligne : renseignez sa marque et son modèle.",
  },
};

export default EDIT_APPLIANCE_ESTIMATES_MODEL_FRENCH_LOCALE;
